import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { ArrowLeftIcon, CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function HireUs() {
  const navigate = useNavigate();
  const [state, handleSubmit] = useForm('xwpkglvj');
  const [formData, setFormData] = useState({
    companyName: '',
    contactName: '',
    email: '',
    phone: '',
    language: '',
    numberOfEmployees: '',
    trainingType: '',
    budget: '',
    startDate: '',
    message: '',
    _replyto: 'thelanguagemagnateacademy@gmail.com',
    _subject: 'New Corporate Training Inquiry'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    if (state.succeeded) {
      setFormData({
        companyName: '',
        contactName: '',
        email: '',
        phone: '',
        language: '',
        numberOfEmployees: '',
        trainingType: '',
        budget: '',
        startDate: '',
        message: '',
        _replyto: 'thelanguagemagnateacademy@gmail.com',
        _subject: 'New Corporate Training Inquiry'
      });
    }
  }, [state.succeeded]);
  return <div className="min-h-screen bg-gradient-to-br from-green-50 to-orange-50 py-24" data-id="element-488">
      <div className="max-w-4xl mx-auto px-6" data-id="element-489">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-slate-700 hover:text-green-600 mb-8 transition-colors duration-200" data-id="element-490">
          <ArrowLeftIcon size={20} data-id="element-491" />
          Back to Home
        </button>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-xl p-8 md:p-12" data-id="element-492">
          <div className="text-center mb-8" data-id="element-493">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-494">
              Corporate <span className="text-green-600" data-id="element-495">Training Inquiry</span>
            </h1>
            <p className="text-lg text-slate-600" data-id="element-496">
              Transform your team's communication with our customized corporate
              language training programs
            </p>
          </div>
          {state.succeeded ? <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center py-12" data-id="element-497">
              <CheckCircleIcon className="text-green-600 mx-auto mb-4" size={64} data-id="element-498" />
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-499">
                Inquiry Submitted Successfully!
              </h2>
              <p className="text-slate-600 mb-8" data-id="element-500">
                Thank you for your interest in our corporate training services.
                Our team will contact you within 24 hours to discuss your needs.
              </p>
              <button onClick={() => navigate('/')} className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 transition-colors duration-200" data-id="element-501">
                Return to Home
              </button>
            </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-502">
              <input type="hidden" name="_replyto" value="thelanguagemagnateacademy@gmail.com" data-id="element-503" />
              <input type="hidden" name="_subject" value="New Corporate Training Inquiry" data-id="element-504" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-505">
                <div data-id="element-506">
                  <label htmlFor="companyName" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-507">
                    Company Name *
                  </label>
                  <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="Your Company Ltd" data-id="element-508" />
                  <ValidationError prefix="Company Name" field="companyName" errors={state.errors} data-id="element-509" />
                </div>
                <div data-id="element-510">
                  <label htmlFor="contactName" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-511">
                    Contact Name *
                  </label>
                  <input type="text" id="contactName" name="contactName" value={formData.contactName} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="John Doe" data-id="element-512" />
                  <ValidationError prefix="Contact Name" field="contactName" errors={state.errors} data-id="element-513" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-514">
                <div data-id="element-515">
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-516">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="john@company.com" data-id="element-517" />
                  <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-518" />
                </div>
                <div data-id="element-519">
                  <label htmlFor="phone" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-520">
                    Phone Number *
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" placeholder="+234 XXX XXX XXXX" data-id="element-521" />
                  <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-522" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-523">
                <div data-id="element-524">
                  <label htmlFor="language" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-525">
                    Language Needed *
                  </label>
                  <select id="language" name="language" value={formData.language} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-526">
                    <option value="" data-id="element-527">Select a language</option>
                    <option value="french" data-id="element-528">French</option>
                    <option value="english" data-id="element-529">English</option>
                    <option value="german" data-id="element-530">German</option>
                    <option value="spanish" data-id="element-531">Spanish</option>
                    <option value="multiple" data-id="element-532">Multiple Languages</option>
                  </select>
                  <ValidationError prefix="Language" field="language" errors={state.errors} data-id="element-533" />
                </div>
                <div data-id="element-534">
                  <label htmlFor="numberOfEmployees" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-535">
                    Number of Employees *
                  </label>
                  <select id="numberOfEmployees" name="numberOfEmployees" value={formData.numberOfEmployees} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-536">
                    <option value="" data-id="element-537">Select range</option>
                    <option value="1-5" data-id="element-538">1-5 employees</option>
                    <option value="6-10" data-id="element-539">6-10 employees</option>
                    <option value="11-20" data-id="element-540">11-20 employees</option>
                    <option value="21-50" data-id="element-541">21-50 employees</option>
                    <option value="50+" data-id="element-542">50+ employees</option>
                  </select>
                  <ValidationError prefix="Number of Employees" field="numberOfEmployees" errors={state.errors} data-id="element-543" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-544">
                <div data-id="element-545">
                  <label htmlFor="trainingType" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-546">
                    Training Type *
                  </label>
                  <select id="trainingType" name="trainingType" value={formData.trainingType} onChange={handleChange} required disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-547">
                    <option value="" data-id="element-548">Select type</option>
                    <option value="on-site" data-id="element-549">On-site Training</option>
                    <option value="virtual" data-id="element-550">Virtual Training</option>
                    <option value="hybrid" data-id="element-551">Hybrid (On-site + Virtual)</option>
                  </select>
                  <ValidationError prefix="Training Type" field="trainingType" errors={state.errors} data-id="element-552" />
                </div>
                <div data-id="element-553">
                  <label htmlFor="startDate" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-554">
                    Preferred Start Date
                  </label>
                  <input type="date" id="startDate" name="startDate" value={formData.startDate} onChange={handleChange} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-555" />
                  <ValidationError prefix="Start Date" field="startDate" errors={state.errors} data-id="element-556" />
                </div>
              </div>
              <div data-id="element-557">
                <label htmlFor="budget" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-558">
                  Budget Range
                </label>
                <select id="budget" name="budget" value={formData.budget} onChange={handleChange} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none disabled:bg-slate-100" data-id="element-559">
                  <option value="" data-id="element-560">Select budget range</option>
                  <option value="under-500k" data-id="element-561">Under ₦500,000</option>
                  <option value="500k-1m" data-id="element-562">₦500,000 - ₦1,000,000</option>
                  <option value="1m-2m" data-id="element-563">₦1,000,000 - ₦2,000,000</option>
                  <option value="2m-5m" data-id="element-564">₦2,000,000 - ₦5,000,000</option>
                  <option value="5m+" data-id="element-565">₦5,000,000+</option>
                </select>
                <ValidationError prefix="Budget" field="budget" errors={state.errors} data-id="element-566" />
              </div>
              <div data-id="element-567">
                <label htmlFor="message" className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-568">
                  Additional Information *
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} disabled={state.submitting} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-green-600 focus:ring-2 focus:ring-green-200 transition-colors duration-200 outline-none resize-none disabled:bg-slate-100" placeholder="Tell us about your training needs, goals, and any specific requirements..." data-id="element-569" />
                <ValidationError prefix="Message" field="message" errors={state.errors} data-id="element-570" />
              </div>
              <button type="submit" disabled={state.submitting} className="w-full bg-green-600 text-white py-4 rounded-lg font-semibold hover:bg-green-700 transition-all duration-200 shadow-lg hover:shadow-xl disabled:bg-slate-400 disabled:cursor-not-allowed" data-id="element-571">
                {state.submitting ? 'Submitting...' : 'Submit Inquiry'}
              </button>
            </form>}
        </motion.div>
      </div>
    </div>;
}